<template>
  <div>
    <b-modal
      ref="createLayer"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <j-title-header :options="title"/>
      <div>
        <j-layer-form
          ref="layerForm"
          mode="create"
          @data="getData"/>
      </div>
      <br>
      <b-row>
        <b-col>
          <div class="float-to-right">
            <b-button
              class="btn blue m__r--5"
              @click="saveCreateLayer">
              Create
            </b-button>
            <b-button
              class="btn gray"
              @click="closePage">
              Close
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import jLayerForm from '@/views/layer/jLayerForm';
import { mapActions } from 'vuex';

export default {
  components: {
    jLayerForm,
  },
  data() {
    return {
      layer_data: null,
      title: {
        main_title: 'CREATE LAYER',
      },
    };
  },
  computed: {
    // prepare data form to hit API
    generateData() {
      return {
        id: this.layer_data.id,
        name: this.layer_data.name,
        code: this.layer_data.code,
        layer_head_id: this.layer_data.parent ? this.layer_data.parent.id : null,
      };
    },
  },
  mounted() {
    // show modal when this component mounted
    this.$refs.createLayer.show();
  },
  methods: {
    ...mapActions('jStoreLayer', ['createLayer']),

    saveCreateLayer() {
      // when .save() executed, getData method will run
      // and layer_data will contain value from data_layer
      this.$refs.layerForm.save();
      if (this.layer_data !== null) {
        // will call method in store
        this.createLayer(this.generateData);
        this.closePage();
      }
    },

    getData(data) {
      this.layer_data = data;
    },
    closePage() {
      this.$emit('closemodal');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/layer/jLayerCreate.vue